import { GET_IP_LOADING, GET_IP_SUCCESS, GET_IP_ERROR } from "../actions/actionIP";

const initialState = {
    IpInfo: {},
    loading: false,
    IpInfoError: ''
};

function reducerIP(state = initialState, action) {
    switch (action.type) {
        case GET_IP_LOADING: {
            return {
                ...state,
                loading: true,
                IpInfo: {},
                IpInfoError: ''
            };
        }

        case GET_IP_SUCCESS: {
            window['info'].ip = action.payload;
            return {
                ...state,
                loading: false,
                IpInfo: action.payload,
                IpInfoError: ''
            };
        }
        case GET_IP_ERROR: {
            return {
                ...state,
                loading: false,
                IpInfo: {},
                IpInfoError: action.error
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerIP;